<template>
    <div>
        <loading-component :value="loading"></loading-component>
        <v-form ref="form">
            <v-layout class="pa-4" wrap>
                <v-flex xs12 md2>
                    <v-checkbox :label="on === 'CAPTAIN' ? 'On ride' : 'On booking'" v-model="onBooking"/>
                </v-flex>
                <v-flex xs12 md10 v-if="onBooking">
                    <v-text-field
                            type="number"
                            :rules="[val => !!val || 'this field is required' , val => val > 0 || 'must be positive']"
                            label="Booking Id"
                            v-model="booking_id"/>
                </v-flex>
                <v-flex xs12 md10 v-else>
                    <v-text-field label="Date" v-model="date" type="date"/>
                    <v-text-field label="Time" v-model="time" type="time"/>
                </v-flex>
                <v-flex xs12>
                    <v-select
                            :items="['CAPTAIN','PASSENGER']"
                            label="On Captain / Passenger"
                            v-model="on"
                    ></v-select>
                </v-flex>
                <v-flex v-if="!onBooking" xs12>
                    <choose-captains-multi
                            v-if="on === 'CAPTAIN'"
                            :multi="false"
                            label="Captain"
                            :rules="[val => !!val || 'this field is required']"
                            v-model="captain_id"
                    />
                    <choose-passenger-multi
                            v-if="on === 'PASSENGER'"
                            :multi="false"
                            label="Passenger"
                            :rules="[val => !!val || 'this field is required']"
                            v-model="passenger_id"/>
                </v-flex>
                <v-flex xs12 md8>
                    <v-text-field required
                                  :rules="[val => !!val || 'this field is required' , val => val > 0 || 'must be positive']"
                                  v-model="amount"

                                  label="Amount"/>
                </v-flex>
                <v-flex xs12 md3 offset-md1>
                    <v-select
                            :items="on === 'CAPTAIN' && !onBooking ? ['CASH','KM','HOUR'] : ['CASH']"
                            v-model="unit"
                            label="Unit"
                    />
                </v-flex>
                <v-flex xs12>
                    <v-textarea label="Note" v-model="note"/>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-btn color="primary" round large class="title" @click="addPenalty">
                    Submit
                </v-btn>
            </v-layout>
        </v-form>
    </div>
</template>

<script>
    import LoadingComponent from "@/components/LoadingComponent";
    import ChooseCaptainsMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import moment from "moment";

    export default {
        name: "Penalty",
        components: {ChooseDate, ChoosePassengerMulti, ChooseCaptainsMulti, LoadingComponent},
        data() {
            return {
                loading: false,
                onBooking: true,
                on: "CAPTAIN",
                unit: 'CASH',
                note: null,
                booking_id: null,
                ride_id: null,
                passenger_id: null,
                amount: null,
                captain_id: null,
                datetime: moment().format("YYYY-MM-DD HH:mm"),
            };
        },
        computed: {
            date: {
                set(val) {
                    this.datetime = moment(val).format("YYYY-MM-DD ") + moment(this.datetime).format("HH:mm");
                },
                get() {
                    return this.datetime.split(" ")[0];
                }
            },
            time: {
                set(val) {
                    this.datetime = moment(this.datetime).format("YYYY-MM-DD ") + val
                },
                get() {
                    return this.datetime.split(" ")[1];
                }
            }
        },
        watch: {
            on(val) {
                if (val === 'PASSENGER')
                    this.unit = 'CASH';
            },
            onBooking(val) {
                if (!val) {
                    this.booking_id = null;
                }
            }

        },
        methods: {
            addPenalty() {
                if (!this.$refs.form.validate())
                    return;
                this.loading = true;
                this.axios.post(this.api.ACTIONS.PENALTY, this.$data)
                    .then(
                        () => window.getApp.$emit("SHOW_TOAST", "Saved", "green")
                    )
                    .catch(
                        ({response}) => window.getApp.$emit("SHOW_TOAST", response.data.message, "red")
                    )
                    .finally(
                        () => this.loading = false
                    );
            }
        }
    }
</script>

<style scoped>

</style>